module.exports = ".login-field {\r\n  text-align: center;\r\n}\r\n\r\n.login-card {\r\n  max-width: 400px;\r\n  margin-left: auto;\r\n  margin-right: auto;\r\n  margin-top: 60px;\r\n}\r\n\r\n.login-card mat-card-header mat-card-title {\r\n    font-weight:bold;\r\n    font-size:large;\r\n  }\r\n\r\n.login-card mat-card-content mat-form-field {\r\n    width: 100%;\r\n  }\r\n\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/login/login.component.css
// module id = ./src/app/login/login.component.css
// module chunks = main